export default __webpack_public_path__ + "static/media/aboutImg01.709ffe93.jpg";